// extracted by mini-css-extract-plugin
export var collapsedSummary = "_or-0";